import { useParams, Navigate } from "react-router-dom";
import { PRODUCTS, findProduct } from "@/data/solutions";
import { PRODUCT_ICONS } from "@/components/LineIcons";
import EntityDetailPage from "@/components/EntityDetailPage";
import SEO from "@/components/SEO";
import { TESTIDS } from "@/constants/testIds";

export default function ProductDetail() {
    const { id } = useParams();
    const p = findProduct(id);
    if (!p) return <Navigate to="/products" replace />;

    const siblings = PRODUCTS.map((x) => ({
        id: x.id,
        name: x.name,
        path: `/products/${x.id}`,
        icon: PRODUCT_ICONS[x.id],
        current: x.id === id,
    }));

    return (
        <>
            <SEO
                path={`/products/${p.id}`}
                title={`${p.name}, ${p.tagline || "KyroLabs"}`}
                description={p.summary}
            />
            <EntityDetailPage
                testId={TESTIDS.products.card(p.id)}
                kicker="Product"
                title={p.name}
                tagline={p.tagline}
                body={p.summary}
                subItems={p.subItems}
                subLabel="What's inside"
                accent={p.color}
                image={p.image}
                highlight={p.highlight}
                bookSource={`products-detail:${p.id}`}
                siblings={siblings}
                siblingsLabel="Explore products"
            />
        </>
    );
}
